import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import client from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import VerifiedBadge, { isVerified } from "../components/VerifiedBadge";
import { useAuth } from "../context/AuthContext";
import { Crown, Eye, Heart, X } from "lucide-react";
import { toast } from "sonner";

const PLACEHOLDER = "https://images.pexels.com/photos/8629727/pexels-photo-8629727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const Admirers = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await client.get("/admirers");
        setList(res.data.admirers);
      } catch (err) {
        if (err?.response?.status === 402) setLocked(true);
        else toast.error("Falha ao carregar.");
      } finally { setLoading(false); }
    })();
  }, []);

  const act = async (id, kind) => {
    try {
      await client.post(`/${kind}`, { target_user_id: id });
      setList((l) => l.filter(x => x.profile.id !== id));
      if (kind === "like") toast.success("Ligação criada!");
    } catch { toast.error("Falha."); }
  };

  if (locked) {
    return (
      <div className="min-h-screen bg-[#0C0E12]" data-testid="admirers-locked">
        <Navbar />
        <main className="max-w-xl mx-auto px-6 py-20 text-center">
          <Crown className="w-12 h-12 text-[#C5A880] mx-auto" />
          <h1 className="font-display text-4xl mt-6">Funcionalidade Premium</h1>
          <p className="text-[#A29F9B] mt-3">
            Ver quem te deu like é uma vantagem exclusiva da subscrição Premium.
          </p>
          <Link to="/premium" className="btn-primary inline-block mt-8" data-testid="upgrade-cta">Subscrever Premium</Link>
        </main>
        <Footer />
    </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0C0E12]" data-testid="admirers-page">
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 md:px-12 py-10">
        <div className="flex items-center gap-2 mb-3">
          <Eye className="w-4 h-4 text-[#C5A880]" />
          <span className="label-uppercase">Quem te deu like</span>
        </div>
        <h1 className="font-display text-3xl md:text-5xl mt-2 mb-10">Pessoas interessadas em ti</h1>

        {loading && <div className="text-[#A29F9B]">A carregar...</div>}
        {!loading && list.length === 0 && (
          <div className="bg-[#161920] border border-white/5 rounded-2xl p-12 text-center">
            <p className="text-[#A29F9B]">Ainda ninguém te deu like — ou já reagiste a todos.</p>
            <Link to="/discover" className="btn-secondary inline-block mt-6">Voltar a descobrir</Link>
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((a) => (
            <div key={a.profile.id} className="bg-[#161920] border border-white/5 rounded-2xl overflow-hidden" data-testid={`admirer-${a.profile.id}`}>
              <div className="aspect-[3/4] overflow-hidden cursor-pointer relative" onClick={()=>navigate(`/profile/${a.profile.id}`)}>
                <img src={a.profile.photos?.[0] || PLACEHOLDER} alt="" className="w-full h-full object-cover" />
                {isVerified(a.profile) && (
                  <div className="absolute top-3 right-3">
                    <VerifiedBadge size="sm" />
                  </div>
                )}
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-display text-xl">{a.profile.name}, {a.profile.age}</h3>
                  <span className="text-[#C5A880] font-display text-lg">{a.compatibility.overall}%</span>
                </div>
                <div className="mt-4 flex gap-2">
                  <button onClick={()=>act(a.profile.id, "pass")}
                    className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-2 rounded-full border border-white/10 text-[#A29F9B] hover:bg-white/5 text-sm"
                    data-testid={`admirer-pass-${a.profile.id}`}>
                    <X className="w-4 h-4" /> Passar
                  </button>
                  <button onClick={()=>act(a.profile.id, "like")}
                    className="flex-1 inline-flex items-center justify-center gap-1 px-3 py-2 rounded-full bg-[#C5A880] text-[#0C0E12] hover:bg-[#DCC19A] text-sm font-semibold"
                    data-testid={`admirer-like-${a.profile.id}`}>
                    <Heart className="w-4 h-4" /> Conectar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Admirers;
